import clsx from "clsx";
import React from "react";

function Version({ className, short = false }) {
    const packageJson = require("../../../../package.json");
    return (
        <div className={clsx("version", className)}>
            <span className="font-small text--grey">
                {short ? "v" : "Version "}
                {packageJson.version}
            </span>
        </div>
    );
}

export default Version;
